import { render, staticRenderFns } from "./CardContainer.vue?vue&type=template&id=f3135b9c&scoped=true&"
import script from "./CardContainer.vue?vue&type=script&lang=js&"
export * from "./CardContainer.vue?vue&type=script&lang=js&"
import style0 from "./CardContainer.vue?vue&type=style&index=0&id=f3135b9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3135b9c",
  null
  
)

export default component.exports